import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useTransition, animated } from 'react-spring';

const InfoScreenTabs = props => {
  const [activeTabId, setActiveTabId] = useState(props.defaultTabId || props.children[0].props.id);

  const tabContentTree = props.children.reduce(
    (acc, x) => ({ ...acc, [x.props.id]: { children: x.props.children } }),
    {},
  );

  const transitions = useTransition(activeTabId, p => p, {
    from: { opacity: 0, transform: 'translate3d(0%, 0, 0)' },
    enter: { opacity: 1, transform: 'translate3d(0%, 0, 0)' },
    leave: { position: 'absolute', opacity: 0, transform: 'translate3d(0%, 0, 0)' },
  });

  return (
    <div>
      <InfoScreenTabHeader>
        {props.children.map(x => (
          <InfoScreenTabLink
            key={x.props.id}
            title={x.props.title}
            icon={x.props.icon}
            onClick={() => setActiveTabId(x.props.id)}
            isActive={activeTabId === x.props.id}
          />
        ))}
      </InfoScreenTabHeader>
      <InfoScreenTabBody>
        {transitions.map(({ item, props: transitionProps, key }) => {
          const child = tabContentTree[item];

          return (
            <animated.div
              key={key}
              style={{ ...transitionProps, minHeight: '400px' }}
              {...child}
              className="is-fullwidth"
            ></animated.div>
          );
        })}
      </InfoScreenTabBody>
    </div>
  );
};

InfoScreenTabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  defaultTabId: PropTypes.string,
};

const InfoScreenTab = () => {
  throw new Error();
};

InfoScreenTab.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

const InfoScreenTabHeader = props => {
  return <div className="is-flex justify-content-center">{props.children}</div>;
};

InfoScreenTabHeader.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

const InfoScreenTabLink = props => {
  return (
    <div className={classnames('info-screen-tab', { active: props.isActive })} onClick={props.onClick}>
      <img src={props.icon} />
      <span>{props.title}</span>
    </div>
  );
};

InfoScreenTabLink.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

const InfoScreenTabBody = props => {
  return (
    <div className="is-relative is-flex justify-content-center align-items-center is-fullwidth">{props.children}</div>
  );
};

InfoScreenTabBody.propTypes = {
  children: PropTypes.node.isRequired,
};

const InfoScreenTabContent = props => {
  return (
    <div className="info-screen-tab-content">
      <div className="info-screen-tab-content-part">
        <img src={props.imgPath} width="100%" height="100%" />
      </div>
      <div className="info-screen-tab-content-part">
        <p className="header">{props.title}</p>
        <p className="mt-48px">{props.paragraph1}</p>
        <p className="mt-24px">{props.paragraph2}</p>
      </div>
    </div>
  );
};

InfoScreenTabContent.propTypes = {
  imgPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  paragraph1: PropTypes.string.isRequired,
  paragraph2: PropTypes.string.isRequired,
};

export default {
  Container: InfoScreenTabs,
  Tab: InfoScreenTab,
  Content: InfoScreenTabContent,
};
